import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import { fa } from "vuetify/iconsets/fa";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { useI18n } from "vue-i18n";
import i18n from "@/plugins/languages";

const xmartShelf = {
  dark: false,
  colors: {
    background: "#FAFAFA",
    surface: "#FFFFFF",
    success: "#06847B",
    error: "#F26C66",
    waiting: "#F2B166", // #F2B166
    primary: "#8B35C1", //  #8B35C1
    secondary: "#1A365D", // #1A365D
    focus: "#46076d", // #46076d
    hover: "#d098ec", // #d098ec
    gradient: "#883ac1", // #883ac1
    selectHover: "#efedff", // #d098ec
    icons: "#60758D" // #60758D
  },
  variables: {}
};

const ftx4 = {
  dark: false,
  colors: {
    background: "#FAFAFA",
    surface: "#FFFFFF",
    success: "#06847B",
    error: "#F26C66",
    waiting: "#F2B166", // #F2B166
    primary: "#3ACBC7", // #3ACBC7
    secondary: "#1A365D", // #1A365D
    focus: "#00d5b4", // #00d5b4
    hover: "#97eee9", // #97eee9
    gradient: "#6ADBD8", // #6ADBD8
    selectHover: "#e5f8f8", // #e5f8f8
    icons: "#60758D" // #60758D
  },
  variables: {}
};

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: "mdi",
    sets: {
      fa
    }
  },
  theme: {
    defaultTheme: "ftx4",
    themes: {
      ftx4,
      xmartShelf
    }
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n })
  },
  date: {
    locale: "pt"
  }
});

export default vuetify;
